//
import React, { ReactNode } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import colors from '../../colors';
import { TXT_P, TXT_PP } from '../../constants';

type Props = {
  icon: ReactNode;
  title: string;
  value: string | number;
};

const CardInfo: React.FC<Props> = (props) => {
  const { icon, title, value } = props;
  return (
    <View
      style={{
        overflow: 'hidden',
        flex: 1,
        // marginLeft: 15,
        // marginRight: 15,
        borderWidth: 1,
        borderColor: colors.lightGrey,
        borderRadius: 7,
        maxWidth: 90
      }}
    >
      <View
        style={{
          backgroundColor: colors.lightGrey,
          alignItems: 'center',
          paddingTop: 5,
          paddingBottom: 5
        }}
      >
        {icon}
        <Text style={{ fontSize: TXT_PP, color: '#fff', fontWeight: '700', textAlign: 'center' }}>
          {title}
        </Text>
      </View>
      <View
        style={{
          padding: 5,
          alignSelf: 'center',
          justifyContent: 'center',
          flex: 1
        }}
      >
        <Text style={{ fontSize: TXT_P, textAlign: 'center' }}>{value}</Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({});

export default CardInfo;
